/**
 * いづみ亭 Shopify テーマ JavaScript
 */

(function() {
  'use strict';

  // Mobile Menu Toggle
  function initMobileMenu() {
    const toggleBtn = document.querySelector('[data-menu-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');

    if (toggleBtn && mobileNav) {
      toggleBtn.addEventListener('click', function() {
        const isOpen = mobileNav.classList.contains('is-open');
        mobileNav.classList.toggle('is-open');
        toggleBtn.classList.toggle('is-active');
        toggleBtn.setAttribute('aria-expanded', !isOpen);
      });
    }
  }

  // Smooth Scroll for Anchor Links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Lazy Load Images
  function initLazyLoad() {
    if ('IntersectionObserver' in window) {
      const lazyImages = document.querySelectorAll('img[data-src]');
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        });
      });

      lazyImages.forEach(img => imageObserver.observe(img));
    }
  }

  // Add to Cart AJAX
  function initAddToCart() {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        // Let Shopify handle the form submission
        // This is just for future AJAX implementation
      });
    });
  }

  // Quantity Selector
  function initQuantitySelectors() {
    document.querySelectorAll('.cart__quantity').forEach(container => {
      const input = container.querySelector('input');
      const decrementBtn = container.querySelector('[data-decrement]');
      const incrementBtn = container.querySelector('[data-increment]');

      if (decrementBtn) {
        decrementBtn.addEventListener('click', () => {
          const min = parseInt(input.min) || 1;
          if (parseInt(input.value) > min) {
            input.value = parseInt(input.value) - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      if (incrementBtn) {
        incrementBtn.addEventListener('click', () => {
          input.value = parseInt(input.value) + 1;
          input.dispatchEvent(new Event('change'));
        });
      }
    });
  }

  // Header Scroll Effect
  function initHeaderScroll() {
    const header = document.querySelector('.header');
    if (!header) return;

    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      lastScroll = currentScroll;
    });
  }

  // Scroll Reveal: viewport 入りで is-visible 付与、バッチ内で順次スタガー
  function initScrollReveal() {
    const targets = document.querySelectorAll('.scroll-reveal, .fade-in');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const STAGGER_STEP = 0.05;
    const observer = new IntersectionObserver((entries) => {
      const becameVisible = entries.filter(e => e.isIntersecting);
      becameVisible.forEach((entry, idx) => {
        entry.target.style.transitionDelay = (idx * STAGGER_STEP) + 's';
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(el => observer.observe(el));
  }

  // Initialize on DOM Ready
  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initSmoothScroll();
    initLazyLoad();
    initAddToCart();
    initQuantitySelectors();
    initHeaderScroll();
    initScrollReveal();
  });

})();
